module.exports = __webpack_public_path__ + "img/5m.702fd580.jpg";